require('./reportImportDialog.style.scss');

class ReportImportDialogController {
    constructor($filter, $element, $timeout, $scope, persistence, notificationService, crudService, storageService) {
        this.$filter = $filter;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$scope = $scope;
        this.persistence = persistence;
        this.notificationService = notificationService;
        this.storageService = storageService;
        this.crudService = crudService;
        this.modalTitle = this.$filter('translate')('report.import.title');

        this.reportFilename = {};
        this.report = {};
    }

    $onInit() {
        this.closeId = { close: 'report-import-close', closeIcon: 'report-import-close-icon' };
        this.actionButtons = [
            {
                title: this.$filter('translate')('report.import.button'),
                action: this.importReport.bind(this),
                isDisabled: () =>
                    !this.reportFilename ||
                    (this.reportFilename && !this.reportFilename.content) ||
                    !this.report ||
                    (this.dialogForm && !this.dialogForm.$valid) ||
                    this.busy,
                id: 'reports-importing',
            },
        ];
    }

    onOpen() {
        this.renderCounter = 0;
        this.reportFilename = {};
        this.report = {};

        this.$element.on('keydown', (e) => {
            if (e.keyCode == 13) {
                e.preventDefault();
                e.stopPropagation();
                if (this.dialogForm && !this.dialogForm.$valid) return;
                this.$timeout(() => {
                    if (!this.showModal || this.renderCounter > 0) return;
                    this.renderCounter++;
                    this.importReport();
                }, 0);
            }
        });
    }

    onClose() {
        this.busy = false;
    }

    importReport() {
        let data = new FormData();
        // data.append('report', this.report.content);
        data.append('report', JSON.stringify(this.reportData));

        this.busy = this.crudService
            .uploadFile(
                'POST',
                `subscriptions/${this.storageService.getSubscription().uuid}/protectionSets/${
                    this.storageService.getProtectionSet().uuid
                }/` + 'reports/import',
                data,
                true
            )
            .then(
                (resp) => {
                    this.notificationService.pop(resp.data.message);
                    this.showModal = false;
                    this.onClosed({ report: this.reportData });
                },
                (err) => {}
            )
            .finally(() => {
                this.busy = false;
            });
    }

    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    updateInputFields() {
        this.busy = true;
        setTimeout(() => {
            // if (!this.reportData || (!this.reportData.name || !this.reportData.description)) {
            if (this.isJson(this.report.content)) {
                this.reportData = JSON.parse(this.report.content);
            }
            // }
            this.busy = false;
        }, 10);
    }
}

ReportImportDialogController.$inject = [
    '$filter',
    '$element',
    '$timeout',
    '$scope',
    'reportsPersistence',
    'notificationService',
    'crudService',
    'storageService',
];

const reportImportDialogComponent = {
    controller: ReportImportDialogController,
    template: require('./reportImportDialog.template.html'),
    bindings: {
        showModal: '=',
        onClosed: '&',
    },
};

module.exports = reportImportDialogComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/reports/dialogs/reportImportDialog/reportImportDialog.component.js